import { Controller } from "@hotwired/stimulus"

// Gère les cases à cocher de la matrice de permissions d'un rôle pilote.
// Fournit : tout sélectionner / tout désélectionner (global) et un toggle
// "Tout / Aucun" par groupe de ressources.
export default class extends Controller {
  static targets = ["checkbox"]

  selectAll() {
    this.setAll(true)
  }

  deselectAll() {
    this.setAll(false)
  }

  setAll(value) {
    this.checkboxTargets.forEach((cb) => {
      cb.checked = value
    })
  }

  // Toggle toutes les cases d'un groupe : coche tout si au moins une est
  // décochée, sinon décoche tout.
  toggleGroup(event) {
    const group = event.currentTarget.closest("[data-permission-group]")
    if (!group) return

    const checkboxes = group.querySelectorAll(
      "input[type='checkbox'][data-pilot-permission-checkboxes-target='checkbox']"
    )
    const allChecked = Array.from(checkboxes).every((cb) => cb.checked)

    checkboxes.forEach((cb) => {
      cb.checked = !allChecked
    })
  }
}
